// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ArchiveRouteImport } from './routes/archive'
import { Route as CodexRouteImport } from './routes/codex'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as DiscordRouteImport } from './routes/discord'
import { Route as HiscoresRouteImport } from './routes/hiscores'
import { Route as PremiumRouteImport } from './routes/premium'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as StatsRouteImport } from './routes/stats'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TutorialRouteImport } from './routes/tutorial'
import { Route as UpdatesRouteImport } from './routes/updates'
import { Route as LeaderboardMapIdRouteImport } from './routes/leaderboard_.$mapId'
import { Route as PlayMapIdRouteImport } from './routes/play_.$mapId'
import { Route as ProfileNameRouteImport } from './routes/profile_.$name'
import { Route as ReplayReplayIdRouteImport } from './routes/replay_.$replayId'
import { Route as ProfileNameAchievementsRouteImport } from './routes/profile_.$name_.achievements'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ArchiveRoute = ArchiveRouteImport.update({
            id: '/archive',path: '/archive',getParentRoute: () => rootRouteImport
          })
const CodexRoute = CodexRouteImport.update({
            id: '/codex',path: '/codex',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const DiscordRoute = DiscordRouteImport.update({
            id: '/discord',path: '/discord',getParentRoute: () => rootRouteImport
          })
const HiscoresRoute = HiscoresRouteImport.update({
            id: '/hiscores',path: '/hiscores',getParentRoute: () => rootRouteImport
          })
const PremiumRoute = PremiumRouteImport.update({
            id: '/premium',path: '/premium',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const StatsRoute = StatsRouteImport.update({
            id: '/stats',path: '/stats',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TutorialRoute = TutorialRouteImport.update({
            id: '/tutorial',path: '/tutorial',getParentRoute: () => rootRouteImport
          })
const UpdatesRoute = UpdatesRouteImport.update({
            id: '/updates',path: '/updates',getParentRoute: () => rootRouteImport
          })
const LeaderboardMapIdRoute = LeaderboardMapIdRouteImport.update({
            id: '/leaderboard_/$mapId',path: '/leaderboard/$mapId',getParentRoute: () => rootRouteImport
          })
const PlayMapIdRoute = PlayMapIdRouteImport.update({
            id: '/play_/$mapId',path: '/play/$mapId',getParentRoute: () => rootRouteImport
          })
const ProfileNameRoute = ProfileNameRouteImport.update({
            id: '/profile_/$name',path: '/profile/$name',getParentRoute: () => rootRouteImport
          })
const ReplayReplayIdRoute = ReplayReplayIdRouteImport.update({
            id: '/replay_/$replayId',path: '/replay/$replayId',getParentRoute: () => rootRouteImport
          })
const ProfileNameAchievementsRoute = ProfileNameAchievementsRouteImport.update({
            id: '/profile_/$name_/achievements',path: '/profile/$name/achievements',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ArchiveRoute: ArchiveRoute,CodexRoute: CodexRoute,CookiePolicyRoute: CookiePolicyRoute,DiscordRoute: DiscordRoute,HiscoresRoute: HiscoresRoute,PremiumRoute: PremiumRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ProfileRoute: ProfileRoute,StatsRoute: StatsRoute,TermsRoute: TermsRoute,TutorialRoute: TutorialRoute,UpdatesRoute: UpdatesRoute,LeaderboardMapIdRoute: LeaderboardMapIdRoute,PlayMapIdRoute: PlayMapIdRoute,ProfileNameRoute: ProfileNameRoute,ReplayReplayIdRoute: ReplayReplayIdRoute,ProfileNameAchievementsRoute: ProfileNameAchievementsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)